export const categories = [
  { key: '全部', label: '全部漫画', icon: 'ri-apps-line', count: 12 },
  { key: '悬疑', label: '悬疑推理', icon: 'ri-search-eye-line', count: 2 },
  { key: '恐怖', label: '恐怖惊悚', icon: 'ri-ghost-line', count: 2 },
  { key: '奇幻', label: '奇幻修仙', icon: 'ri-magic-line', count: 2 },
  { key: '冒险', label: '冒险探索', icon: 'ri-compass-3-line', count: 2 },
  { key: '科幻', label: '科幻机甲', icon: 'ri-rocket-line', count: 2 },
  { key: '热血', label: '热血战斗', icon: 'ri-fire-line', count: 2 },
];